import Vue from 'vue'

const eventBus = new Vue()

function showToastSuccess(message) {
  eventBus.$emit('showToast', { icon: 'mdi-check', type: 'success', message })
}

function showExpandedToastSuccess(message, message2) {
  eventBus.$emit('showExpandedToast', { icon: 'mdi-check', type: 'success', message, message2 })
}

function showToastError(message) {
  eventBus.$emit('showToast', { icon: 'mdi-block-helper', type: 'error', message })
}

function showConfirmationDialog(title, text, checkBoxChecked, checkBoxLabel) {
  eventBus.$emit('showConfirmationDialog', { title, text, checkBoxChecked, checkBoxLabel })
  return new Promise(resolve => {
    eventBus.$once('confirmationAccept', data => resolve({ confirmedValue: data.param, confirmedCheckboxValue: data.param2 }))
  })
}

export default eventBus
export { showToastSuccess, showToastError, showExpandedToastSuccess, showConfirmationDialog }
